// Component generated with util/vox-create-component.js
import * as AuthCommons from './AuthCommons.styled';

export default AuthCommons;
